import __request__ from "routing/request";
export function override(nodeId, status) {
  return __request__("PUT", `/cluster/${nodeId}/lbstatus/override/${status}`, null, {}, {
    "Accept": ["application/json"]
  });
}
